<template>

    <v-tooltip bottom style="width: 32px;">
      <template v-slot:activator="{ on, attrs }">
        <v-btn  dark x-small   v-bind="attrs"
               v-on="on" style="font-size: 14px !important; opacity: 0.35 !important;">
        ?
        </v-btn>
      </template>
      <span>{{ text }}</span>
    </v-tooltip>

</template>

<script>
export default {
  props:['text'],
  data() {
    return {
    }
  },
  computed:{
  //  show(){
   //   return this.$store.state.help;
  //  }
  }
}
</script>
